import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Chip from '@mui/material/Chip';
import { Blockchain02Icon, LibraryIcon } from 'hugeicons-react';
import { Stack, useTheme } from '@mui/material';
export default function MachineLibraryChip(_a) {
    var label = _a.label;
    var theme = useTheme();
    return (_jsxs(Stack, { flexDirection: 'row', gap: 1, children: [_jsx(Chip, { size: 'small', variant: 'soft', label: label[0], sx: {
                    background: '#919EAB14',
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(Blockchain02Icon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) }), _jsx(Chip, { size: 'small', variant: 'soft', label: label[1], sx: {
                    background: '#919EAB14',
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(LibraryIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) })] }));
}
